var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFolderDocumentation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 20.2543H3C2.17155 20.2543 1.5 19.5827 1.5 18.7543V3.75428C1.5 2.92583 2.17155 2.25428 3 2.25428L8.3775 2.25C8.77725 2.2497 9.16065 2.409 9.4425 2.6925L12 5.25428L21 5.25C21.8284 5.25 22.5 5.92155 22.5 6.75V9.75428H21V6.75428L11.3775 6.75L10.9425 6.3075L8.3775 3.75L3 3.75428V18.7543H9V20.2543ZM12 12.0043L10.4946 12L10.5 20.2543H12V12.0043ZM22.4965 13.4987L22.4936 20.823C22.4936 21.3359 22.0679 21.7543 21.5446 21.7543H14.4436C13.9203 21.7543 13.4946 21.3359 13.4946 20.8223V11.4327C13.4946 10.9184 13.9203 10.5 14.4436 10.5L19.5 10.5043L22.5 13.5043L22.4965 13.4987ZM20.9924 20.2546L21 14.2543H18.75V12.0043H15V20.2543H21L20.9924 20.2546Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFolderDocumentation);
export default __webpack_public_path__ + "static/media/ic-folder-documentation.38b8635c82720cd46e79f58bcc3b023f.svg";
export { ForwardRef as ReactComponent };